/* Editorial archive strip — continuous marquee with a centre-weighted scale.

   Why it is built this way, from three failed attempts:

   1. The track is moved with `transform`, never scrollLeft. Animating
      scrollLeft makes the browser reprocess scrolling every frame, and CSS
      scroll-snap silently rejects the small incremental writes and springs
      the strip back to the nearest snap point. That combination produced both
      the stutter and a travel that stepped between snap points.
   2. Item positions are CALCULATED, not measured. Reading
      getBoundingClientRect for every shot every frame forces a layout pass per
      frame. The geometry is a fixed-pitch row, so each centre is just
      index * (size + gap) + size/2 - offset. Measurement happens only on
      resize.
   3. The loop reschedules itself before doing anything else, so it can never
      die, and it never depends on IntersectionObserver to start or resume.

   The shots are rendered twice by the Liquid snippet; the offset wraps by one
   set width, so the motion is seamless.
*/
(function () {
  function init(view) {
    var track = view.querySelector('.gx-arch__track');
    if (!track) return;
    var figs = Array.prototype.slice.call(track.children);
    var n = figs.length;
    if (n < 2) return;

    var MAX = 1.45;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var speed = parseFloat(view.getAttribute('data-speed'));
    if (isNaN(speed)) speed = 34;          /* pixels per second */

    var size = 0, gap = 0, pitch = 0, setW = 0, viewW = 0;
    var x = 0, vel = 0, last = 0, raf = null;
    var hover = false, down = false;
    var sx = 0, sOff = 0, lx = 0, lt = 0;

    function measure() {
      size = figs[0].offsetWidth || 1;
      var cs = getComputedStyle(track);
      gap = parseFloat(cs.columnGap || cs.gap) || 0;
      pitch = size + gap;
      setW = pitch * (n / 2);            /* one copy of the set */
      viewW = view.clientWidth || 1;
    }

    function frame(t) {
      raf = requestAnimationFrame(frame);

      var dt = last ? Math.min(64, t - last) : 16;
      last = t;

      if (setW <= 0) { measure(); if (setW <= 0) return; }

      if (down) {
        /* the viewer is driving */
      } else if (Math.abs(vel) > 0.01) {
        x += vel * dt;                   /* momentum after a flick */
        vel *= Math.pow(0.9, dt / 16);
      } else if (!hover && !reduce.matches && speed > 0) {
        x += (speed / 1000) * dt;        /* the marquee itself */
      }

      while (x >= setW) x -= setW;       /* seamless wrap */
      while (x < 0) x += setW;

      track.style.transform = 'translate3d(' + (-x).toFixed(2) + 'px,0,0)';

      if (reduce.matches) return;

      var cx = viewW / 2;
      var falloff = size * 1.55;
      for (var i = 0; i < n; i++) {
        var c = i * pitch + size / 2 - x;      /* calculated, not measured */
        var d = c - cx; if (d < 0) d = -d;
        var s = 1;
        if (d < falloff) {
          var k = 1 - d / falloff;
          k = k * k * (3 - 2 * k);             /* smoothstep */
          s = 1 + (MAX - 1) * k;
        }
        var f = figs[i];
        if (f._s !== s) {
          f.style.transform = 'scale(' + s.toFixed(3) + ')';
          f.style.zIndex = s > 1.02 ? '2' : '1';
          f._s = s;
        }
      }
    }

    /* ---------- pause ---------- */
    view.addEventListener('mouseenter', function () { hover = true; });
    view.addEventListener('mouseleave', function () { hover = false; });
    view.addEventListener('focusin', function () { hover = true; });
    view.addEventListener('focusout', function () { hover = false; });

    /* ---------- drag, mouse and touch ---------- */
    view.addEventListener('pointerdown', function (e) {
      down = true; vel = 0;
      sx = e.clientX; sOff = x;
      lx = e.clientX; lt = performance.now();
      view.classList.add('is-drag');
      try { view.setPointerCapture(e.pointerId); } catch (err) {}
    });

    view.addEventListener('pointermove', function (e) {
      if (!down) return;
      x = sOff - (e.clientX - sx);
      var now = performance.now(), dt = now - lt;
      if (dt > 0) { vel = -(e.clientX - lx) / dt; lx = e.clientX; lt = now; }
    });

    function release() {
      if (!down) return;
      down = false;
      view.classList.remove('is-drag');
      if (Math.abs(vel) > 3) vel = vel > 0 ? 3 : -3;   /* cap a hard flick */
    }
    view.addEventListener('pointerup', release);
    view.addEventListener('pointercancel', release);
    view.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* ---------- keyboard ---------- */
    view.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { x += pitch; e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { x -= pitch; e.preventDefault(); }
    });

    window.addEventListener('resize', measure);
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(view);
    if (reduce.addEventListener) reduce.addEventListener('change', measure);

    measure();
    /* Images load lazily, so re-measure once they have settled. */
    setTimeout(measure, 600);
    window.addEventListener('load', measure);

    raf = requestAnimationFrame(frame);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.gx-arch__view'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
